import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";

export class AthleteGameLineupsApiService extends BaseApiService {}